// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"278":"5680c9f2","710":"418e8853","719":"c78bf051"}[chunkId] + ".css";
};